import { Component, EventEmitter, Input, OnChanges, Output, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { GroupBase } from '../../../models/blueprint.model';
import { RecordUpdateEmission, ReportInfo, ReportRecord, ReportView } from '../../../models/report.model';
import { PropertyGroup, PropertyGroupQuery, TemplateField } from '../../../models/template.model';
import { ReportExportViewService } from '../../../report-export-view.service';
import { PropertyGroupService } from '../../../report-group.service';
import { IMAGE_FIELD_ID } from '../../../shared/templates/config/common';
import { LocaleKeys } from '../../../shared/templates/utils/template-display-sort-order.const';
import { EditableFieldsService } from '../../editable-fields.service';

@Component({
  // eslint-disable-next-line
  selector: 'compare-record-body',
  templateUrl: './compare-record-body.component.html',
  styleUrls: ['./compare-record-body.component.scss'],
  standalone: false,
})
export class CompareRecordBodyComponent implements OnChanges {
  @Input() confidentialityTmpl: TemplateRef<any>;
  @Input() allFields: TemplateField[];
  @Input() allDataFields: TemplateField[];
  @Input() record: ReportRecord;
  @Input() currentView: ReportView;
  @Input() groupsToDisplay: GroupBase<TemplateField>[];
  @Input() order: number;
  @Input() recordList: any[];
  @Input() reportData: ReportInfo;
  @Input() reportLocale: number;
  @Input() showGroup: boolean;
  @Input() propertyGroups: PropertyGroup[] = [];
  @Output() reportUpdateClick: EventEmitter<RecordUpdateEmission> = new EventEmitter<RecordUpdateEmission>();
  @Output() public removeRecord: EventEmitter<number> = new EventEmitter();

  imageField: TemplateField;
  isChina = false;
  selectedValue = 0;
  associationID: number;
  recordLevelGroups: PropertyGroup[] = [];
  constructor(
    public editableFieldsService: EditableFieldsService,
    private router: Router,
    private reportExportViewService: ReportExportViewService,
    private propertyGroupService: PropertyGroupService
  ) {}

  ngOnChanges() {
    this.editableFieldsService.mapEditableFields(this.groupsToDisplay);
    this.imageField = (this.allFields || []).find(field => field.id === IMAGE_FIELD_ID);
    if ([LocaleKeys.ChinaChinese, LocaleKeys.ChinaEnglish].includes(this.reportLocale)) {
      this.isChina = true;
    }
    this.recordLevelGroups = [];
    if (this.propertyGroups && this.propertyGroups.length > 0 && this.record) {
      this.setGroupOptions();
    }
  }

  emitEditableFields(event: MouseEvent, id: number) {
    const emittedObject = this.editableFieldsService.generateRecordUpdateEmission(event, id, this.record.data);
    if (emittedObject != null) {
      this.reportUpdateClick.emit(emittedObject);
    }
  }

  goToRecordDetails() {
    const { entity } = this.reportData;
    const currentRecordId = this.record.edpRecordId;
    const url = `/records/${entity}/${currentRecordId}/edit`;
    this.router.navigateByUrl(url);
  }

  setGroupOptions() {
    let nextGroupName = 1;
    this.recordLevelGroups = this.propertyGroups
      .map(group => {
        const groupName = Number(group.groupName);
        nextGroupName = groupName >= nextGroupName ? groupName + 1 : nextGroupName;
        if (
          group.relatedRecordID === this.record.associatedPropertyId &&
          group.recordID === this.record.data.entity.id
        ) {
          this.selectedValue = group.groupID;
          this.associationID = group.associationID;
        }
        return { ...group, isDisabled: group.relatedRecordID !== this.record.associatedPropertyId };
      })
      .reduce(
        (uniqueGroup, groupItem) =>
          uniqueGroup.some(grp => grp.groupName === groupItem.groupName) ? uniqueGroup : [...uniqueGroup, groupItem],
        []
      );
    this.propertyGroupService.groupName = nextGroupName;
  }

  selectionChanged() {
    if (this.selectedValue === 0) {
      // if selected value 0 then delete
      this.deleteGroupAssociation();
    } else if (this.selectedValue === -1) {
      // if selected value -1 then create new
      const query: PropertyGroupQuery = {
        recordID: this.record.data.entity.id,
        relatedRecordID: this.record.associatedPropertyId,
        groupName: this.propertyGroupService.groupName.toString(),
      };
      this.addUpdateGroupAssociation(query);
      this.propertyGroupService.groupName = this.propertyGroupService.groupName + 1;
    } else {
      //update
      const query: PropertyGroupQuery = {
        recordID: this.record.data.entity.id,
        relatedRecordID: this.record.associatedPropertyId,
        groupID: this.selectedValue,
      };
      this.addUpdateGroupAssociation(query);
    }
  }

  private addUpdateGroupAssociation(query: PropertyGroupQuery) {
    this.reportExportViewService
      .associatePropertyGroup(this.reportData.reportId, this.currentView.id, query)
      .subscribe((res: PropertyGroup[]) => {
        this.propertyGroupService.setReportPropertyGroups(res);
      });
  }

  private deleteGroupAssociation() {
    this.reportExportViewService
      .deletePropertyGroup(this.reportData.reportId, this.currentView.id, this.associationID)
      .subscribe((res: PropertyGroup[]) => {
        this.propertyGroupService.setReportPropertyGroups(res);
      });
  }
}
